import hasWindow from './hasWindow';

export function getQueryParamByName(name: string) {
  if (!hasWindow()) {
    return '';
  }

  const decodeURI = decodeURIComponent(window.location.search);

  const searchParams = new URLSearchParams(decodeURI);
  return searchParams.get(name) || '';
}
